// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__c80eT","checkboxCol":"Table_checkboxCol__3EOrt","emailCol":"Table_emailCol__1lZ-O","actionCol":"Table_actionCol__3kIer"};